import { render, staticRenderFns } from "./HorizontalContent.vue?vue&type=template&id=29b8ac1b&"
import script from "./HorizontalContent.vue?vue&type=script&lang=js&"
export * from "./HorizontalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports